import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../firebase';
import { collection, getDocs, onSnapshot, query } from 'firebase/firestore';
import { automationsLoadedAction } from '../../../actions/preloaded';
import { dataCompletedAction } from '../../../actions/store';

const useAutomationsLoader = () => {
  const [options, setOptions] = useState({ execute: false });
  const dispatch = useDispatch();

  const load = () => {
    dispatch(dataCompletedAction({ slice: 'Preloaded', path: 'automations' }));

    return onSnapshot(
      collection(db, 'automations'),
      async querySnapshot => {
        const items = [];

        querySnapshot.forEach(doc => {
          const dataItem = doc.data();
          dataItem.id = doc.id;

          if (!dataItem.conditions || dataItem.conditions === '') {
            dataItem.conditions = [];
          } else {
            dataItem.conditions = JSON.parse(dataItem.conditions);
          }

          items.push(dataItem);
        });

        await Promise.all(
          items.map(async automation => {
            automation.steps = [];
            const automationSteps = await getDocs(
              query(
                collection(db, `automations/${automation.id}/automation_steps`)
              )
            );

            automationSteps.forEach(step => {
              automation.steps.push(step.data());
            });

            return automation;
          })
        );

        dispatch(automationsLoadedAction(items));
      },
      error => {
        console.error('useAutomationsLoader.onSnapshot', error);
      }
    );
  };

  useEffect(() => {
    let unSub = () => {};
    if (options.execute) {
      unSub = load();
    }
    return () => {
      unSub();
    };
  }, [options]);

  return {
    loadAutomations: (options = {}) => {
      setOptions({ ...options, execute: true });
    }
  };
};

export default useAutomationsLoader;
